import React from 'react';
import { useReveal } from '../lib/useReveal';
import { trackEvent } from '../lib/pixel';
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  return <section id="pricing" className="bg-[#0a0e1f] py-10 md:py-16 px-4 sm:px-6 border-t border-[#ffffff]/5" style={{
    scrollMarginTop: '20px'
  }} data-id="element-143">
      <div className="container mx-auto max-w-5xl" data-id="element-144">
        <div ref={ref1} className={`reveal text-center mb-8 md:mb-12 ${vis1 ? 'is-visible' : ''}`} data-id="element-145">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#f5f1e6] mb-4" data-id="element-146">
            ELEGÍ COMENZAR HOY
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center max-w-4xl mx-auto" data-id="element-147">
          {/* Left Column - What you get */}
          <div className="bg-[#11152e] p-6 md:p-8 rounded-2xl border border-[#d4af37]/15 shadow-sm" data-id="element-148">
            <h3 className="text-xl md:text-2xl font-serif font-bold text-[#f5f1e6] mb-6" data-id="element-149">
              TODO LO QUE RECIBÍS HOY
            </h3>
            <ul className="space-y-4" data-id="element-150">
              <li className="flex items-center gap-3" data-id="element-151">
                <span className="text-2xl" data-id="element-152">📚</span>
                <span className="text-[#cbd0e0] font-medium" data-id="element-153">
                  6 Módulos Profesionales
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-154">
                <span className="text-2xl" data-id="element-155">🎁</span>
                <span className="text-[#cbd0e0] font-medium" data-id="element-156">
                  4 Bonos Exclusivos
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-157">
                <span className="text-2xl" data-id="element-158">📜</span>
                <span className="text-[#cbd0e0] font-medium" data-id="element-159">
                  Certificado Digital
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-160">
                <span className="text-2xl" data-id="element-161">⚡</span>
                <span className="text-[#cbd0e0] font-medium" data-id="element-162">
                  Acceso Inmediato
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-163">
                <span className="text-2xl" data-id="element-164">💻</span>
                <span className="text-[#cbd0e0] font-medium" data-id="element-165">100% Digital</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-166">
                <span className="text-2xl" data-id="element-167">🔓</span>
                <span className="text-[#cbd0e0] font-medium" data-id="element-168">
                  Acceso Ilimitado
                </span>
              </li>
            </ul>
          </div>

          {/* Right Column - Pricing Card */}
          <div className="relative bg-[#1a1f3d] border-2 border-[#d4af37]/80 shadow-xl rounded-2xl p-6 md:p-8 flex flex-col" data-id="element-169">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#d4af37] text-[#0a0e1f] text-xs font-bold tracking-[0.2em] px-6 py-2 rounded-full whitespace-nowrap shadow-md" data-id="element-170">
              OFERTA ESPECIAL
            </div>

            <h3 className="text-xl md:text-2xl font-serif font-bold text-[#f5f1e6] mb-2 text-center mt-2" data-id="element-171">
              MEGAPACK ASTROLOGÍA INTEGRAL
            </h3>

            <div className="bg-[#0a0e1f] rounded-xl p-4 mb-6 border border-[#d4af37]/20" data-id="element-172">
              <p className="text-[#8b91ad] text-xs font-bold uppercase tracking-wider mb-3" data-id="element-173">
                Incluye:
              </p>
              <ul className="space-y-2" data-id="element-174">
                {['6 Módulos Profesionales', '4 Bonos Exclusivos', 'Certificado Digital', 'Acceso Inmediato', 'Acceso Ilimitado', 'Formación Completa'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-175">
                    <span className="text-[#d4af37] font-bold text-sm" data-id="element-176">✓</span>
                    <span className="text-[#cbd0e0] text-sm font-medium" data-id="element-177">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="text-center mb-6" data-id="element-178">
              <p className="text-[#d4af37] text-sm font-bold uppercase tracking-widest mb-1" data-id="element-179">
                HOY SOLO
              </p>
              <div className="flex items-baseline justify-center gap-1.5" data-id="element-180">
                <span className="text-4xl md:text-5xl font-extrabold text-[#f5f1e6] leading-none" data-id="element-181">
                  $19.990
                </span>
                <span className="text-[#8b91ad] text-sm font-semibold" data-id="element-182">
                  ARS
                </span>
              </div>
            </div>

            <a href="https://academiaholisticaargentina.com/cart/49011250659578:1" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
            content_name: 'MegaPack Astrología Integral',
            value: 19990,
            currency: 'ARS'
          })} className="w-full block py-4 rounded-xl font-bold text-sm md:text-base tracking-widest uppercase text-center transition-all hover:-translate-y-1 bg-[#d4af37] hover:bg-[#c19b2e] text-[#0a0e1f] shadow-[0_8px_20px_rgba(212,175,55,0.3)] hover:shadow-[0_12px_25px_rgba(212,175,55,0.4)]" style={{
            fontFamily: "'Inter', sans-serif"
          }} data-id="element-183">
              👉 QUIERO ACCEDER AHORA
            </a>

            <div className="mt-4 text-center space-y-2" data-id="element-184">
              <p className="text-[#8b91ad] text-xs font-medium" data-id="element-185">
                ⚡ Acceso inmediato luego de completar tu compra.
              </p>
              <p className="text-[#8b91ad] text-xs font-medium" data-id="element-186">
                🛡️ Garantía de satisfacción de 7 días.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}